<template>
  <div class="notifications-unsubscribe ctsform">
    <div class="sports-page">
      <v-layout  class="page-layout">
        <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
          <resize-observer @notify="mainColumnResize" />
          <div class="accpage">
            <div class="notifications-unsubscribe__spinner" v-if="isProcessing">
              <v-progress-circular indeterminate class="redirecting-circular-progress"/>
            </div>
            <div v-else>
              <div v-if="unsubscribeSuccessfull" class="notifications__message">
                <v-icon color="success" class="mr-1">check_circle</v-icon>
                {{ $t('NotificationsUnsubscribe.OK') }}
              </div>
              <div v-if="!unsubscribeSuccessfull" class="notifications__message">
                <v-icon color="success" class="mr-1">check_circle</v-icon>
                {{ $t('NotificationsUnsubscribe.ok') }}
              </div>
              <div class="buttons">
                <v-btn
                  class="outlined"
                  color="gray"
                  @click="goToHomepage">
                    <i aria-hidden="true" class="icon material-icons">navigate_before</i>
                    {{$t('Account.ChangePassword.GoToHomepage')}}
                </v-btn>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
  import store from '@/store'
  import lib from '@/library'

  export default {
    data () {
      return {
        isProcessing: false,
        unsubscribeSuccessfull: false
      }
    },
    computed: {
      headerHeight () {
        return store.getters['screenState/getHeaderHeight']
      }
    },
    methods: {
      try2unsubscribe () {
        let token = this.getToken()
        if (!token) {
          console.error(`NotificationsUnsubscribe.try2unsubscribe | ERROR | Token Not Found`)
          return
        }
        this.unsubscribe(token)
      },
      async unsubscribe (token) {
        try {
          this.isProcessing = true
          const response = await lib.rpcService.callBroker('GamingNotificationService', 'unsubscribewithtoken', {
            token
          })
          if (response && response.result && response.result === 'OK') {
            this.unsubscribeSuccessfull = true
          }
        } catch (error) {
          console.error(`NotificationsUnsubscribe.unsubscribe | ERROR | ${error && error.message}`)
        } finally {
          setTimeout(() => {
            this.isProcessing = false
          }, 1000)
        }
      },
      getToken () {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token')
        return token
      },
      goToHomepage () {
        this.$router.push({ name: 'sports' })
      },
      mainColumnResize () {
        let mainColumn = this.$refs.maincolumn
        if (mainColumn) {
          store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
        }
      }
    },
    mounted () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.try2unsubscribe()
    }
  }
</script>
<style lang="stylus" scoped>
  @import "~@/css/config"    
  .main-column
      display flex
      justify-content center
      min-height: 200px
  .notifications-unsubscribe__spinner
    text-align center
    padding 30px 15px
  .notifications__message
    padding 20px
    display: flex;
    justify-content: center;
    align-items: center;
  .buttons
    display flex
    justify-content center
    .outlined
      background-color: unset!important;
      border: 1px solid;
      color: unset;
</style>



// WEBPACK FOOTER //
// src/components/account/NotificationsUnsubscribeComponent.vue